import { Component, HostListener, Inject, Optional } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GTM } from 'src/app/services/gtm.service';
import { environment } from 'src/environments/environment';
import { MODAL, ModalService } from './services/modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HasUnsavedChanges, UNSAVED_CHANGES_CHECKERS } from './services/interfaces/has-unsaved-changes.interface';
import { CustomerService } from './services/customer.service';
import { logError } from './services/helpers/sentry.helper';

@Component({
  selector: 'ng-casto-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  hideHeader = false;

  @HostListener('window:beforeunload', ['$event'])
  confirmExit(event: BeforeUnloadEvent) {
    if (this.unsavedCheckers?.some(c => c.hasUnsavedChanges())) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  @HostListener('document:keydown.shift.F12', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    this.modalService.display(MODAL.DEBUG_INFOS);
  }

  constructor(
    translate: TranslateService,
    private readonly modalService: ModalService,
    private router: Router,
    private route: ActivatedRoute,
    private readonly customerService: CustomerService,
    public gtm: GTM,
    @Optional() @Inject(UNSAVED_CHANGES_CHECKERS) private unsavedCheckers: HasUnsavedChanges[]
  ) {
    this.router.events.subscribe(() => {
      const currentRoute = this.getDeepestChild(this.route);
      this.hideHeader = currentRoute.snapshot.data['hideHeader'] === true;
    });
    this.gtm.init(environment.tracking);
    this.restoreCiamSession();
    translate.setDefaultLang('en');
    let userLang = navigator.language.toLowerCase();
    if (userLang.indexOf('fr') > -1) {
      translate.use('fr');
    }
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  /**
   * Le jeton HomeByMe n'est plus acquis ici : il l'est à l'ouverture d'un configurateur
   * (`getAuthParams`), sur demande de HomeByMe (`LoginRequired`) ou à l'entrée d'un projet
   * (`CustomerTokenGuard`). Un client qui n'ouvre aucun configurateur n'a pas de compte HBM.
   */
  private restoreCiamSession(): void {
    this.customerService.restoreCiamSession().catch(logError);
  }

  get enableErrorPanel(): boolean {
    return environment.sentry.dsn?.length <= 0;
  }
}
